"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M13.253 7.16l.217.529h2.73v.808H7.8v-.808h2.729l.217-.53a.428.428 0 01.396-.26h1.716c.175 0 .332.104.395.26zM10.005 17.1h3.99c.84 0 1.522-.658 1.522-1.47V9.497H8.483v6.134c0 .811.681 1.469 1.521 1.469z" }), "Delete");
//# sourceMappingURL=Delete.js.map